<template>
  <fn-page-container>
    <fn-newsletter-unsubscribe
      :error="hasError"
      :page="page"
      :email="email"
      :show-confirm="showConfirm"
      @unsubscribe="unsubscribeNewsletter"
    />
  </fn-page-container>
</template>

<script setup lang="ts">
import { getUnsubscribeRedirectCca } from '@/utils/newsletter';

definePageMeta({
  name: 'newsletter-unsubscribe',
  routeCmsPage: () => 'newsletter/unsubscribe',
});

const { $api, $log } = useNuxtApp();
const router = useRouter();
const route = useRoute();
const mainStore = useMainStore();
const newsletterStore = useNewsletterStore();

let page = {};
const hasError = ref(false);
const showConfirm = ref(false);
const email = ref<string>();
const ccaSubscriptionApiEnabled = mainStore.getFeature('ccaSubscriptionApiEnabled');

function unsubscribeNewsletter() {
  newsletterStore
    .unsubscribe(route.params.id)
    .then(() => {
      showConfirm.value = true;
    })
    .catch((error) => {
      hasError.value = true;
      $log.error('Error while unsubscribing from newsletter', error);
    });
}

if (ccaSubscriptionApiEnabled) {
  await router.push(getUnsubscribeRedirectCca(route));
} else {
  page = await mainStore.loadRoutePage(route);

  const { data, error } = await useAsyncData(async () => {
    const { data: newsletter } = await $api.hybris.newsletter.subscription(route.params.id);

    return { newsletter };
  });

  if (unref(error)) {
    hasError.value = true;
    $log.error('Error while loading newsletter unsubscribe page', error);
  }

  email.value = unref(data)?.newsletter?.address?.emailAddress;

  usePageMeta({ page });
}
</script>
